
import React from 'react';

const RadioButtonChoice = ({ legend, options, selectedValue, onChange }) => {
  return (
    <fieldset className='light-green-background p-2'>
      <legend className="text-medium text-center mb-2">{legend}</legend>
      <div className="d-flex flex-column flex-md-row justify-content-center align-items-start align-items-md-center mt-2 gap-2">
        {options.map(({ id, value, label }) => (
          <div
            key={id}
            className="form-check d-flex align-items-center"
            style={{
              minWidth: '200px',
              textAlign: 'left',
            }}
          >
            <input
              className="form-check-input"
              type="radio"
              name="radioOption"
              id={id}
              value={value}
              checked={selectedValue === value}
              onChange={() => onChange(value)}
              aria-label={label}
              style={{ marginRight: '8px' }}
            />
            <label
              className="form-check-label mb-0"
              htmlFor={id}
              style={{ flex: 1, fontSize:'14px' }}
            >
              {label}
            </label>
          </div>
        ))}
        
      </div>
    </fieldset>
  );
};

export default RadioButtonChoice;
